"use client";

import Detailslist from "@/components/Detailslist/Detailslist";
import { fetchHowItWorks, selectAllHowItWorks } from "@/slice/howItsWorkSlice";
import { blogFilter } from "@/utils/data";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import VideoCard from "../components/InformationalVideos/VideoCard/VideoCard";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";

const HowItsWorks = () => {
  const dispatch = useDispatch();
  const howItWorks = useSelector(selectAllHowItWorks);
  const lang = useSelector((state) => state.locale.locale);
  useEffect(() => {
    dispatch(fetchHowItWorks(lang));
  }, [lang]);

  const props = {
    heading: "Search accordingly your convenience",
    filterData: blogFilter,
  };
  return (
    <>
      <BreadCrumbs />
      <Detailslist props={props}>
        {howItWorks.data?.length > 0 &&
          howItWorks.data.map((video, i) => (
            <VideoCard key={i} video={video} />
          ))}
      </Detailslist>
    </>
  );
};

export default HowItsWorks;
